
import React, { useContext, useState, useRef, useEffect, useCallback, forwardRef, useImperativeHandle } from 'react';
import axios from 'axios';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import { Notifications, Help, ArrowDropDown, Upload, UploadFileOutlined, CloseIcon, CloseRounded, } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Avatar,
  Button,
  Badge,
  Box,
  Select,
  Divider,
  Drawer,
  TextField,
  InputLabel,
  FormControl,
  FormControlLabel,
  Checkbox,
  InputAdornment,
  Paper, Tabs,
} from '@mui/material';

import Search from '@mui/icons-material/Search';
import Tab from '@mui/material/Tab';
import { formatDistanceToNow, parseISO } from "date-fns";
import {
    CaseDocumentsModel, caseDocumentsModel,
    TextFieldWithIconButton,
    CollapsibleSection,
    CustomAutoComplete,
    DocumentUtility,
    UtilityLibrary,
    caseDataService,
    batchDataService,
    BusinessUtility,
    ApiManager,
    sessionService,
    SessionManager,
    EnumUtility,
    LoggerUtility,
    ConfirmationDialog,
    NotificationDialog,
    FetchControls,
    DeterminePermissions
} from '../../../components/ComponentsLibrary';


const LegalCaseDetail = forwardRef((props, ref) => {

    const {
        onComponentMount = () => { },
        PrimaryID,

    } = props;

    // Expose the method to the parent via ref
    useImperativeHandle(ref, () => ({
        onLoadLegalDetailByCaseID,
    }));

    useEffect(() => {
        if (onComponentMount) {
            onComponentMount();
        }
    }, []);

    const errorFormName = "Case Detail - Customer Service Contacts";

    const caseDocsDataRefs = useRef([]); // Store DataGrid data persistently

    const contactSearchRef = useRef();

    const [isPageLoading, setIsPageLoading] = useState(false);

    const [resultsLegalDetail, setResultsLegalDetail] = useState([]);
    const [paginationModel, setPaginationModel] = useState({ pageSize: 5, page: 0 });
    const [gridFilterModel, setGridFilterModel] = useState({ items: [] });

    const defaultPermissionsForFields = {
        clearFiltersBtn: { read: false, write: true, hide: false },
        exportDocumentsBtn: { read: false, write: true, hide: false },
        LegalDetailDgrd: { read: false, write: true, hide: false },
        documentViewerVwr: { read: false, write: true, hide: false },
        docVwr1Editor: { read: false, write: true, hide: false },
        docVwr1ToolbarItems: { read: false, write: true, hide: false },
        docVwr2Editor: { read: false, write: true, hide: false },
        docVwr2ToolbarItems: { read: false, write: true, hide: false },
        docVwrSplitBtn: { read: false, write: true, hide: false },
    }
    const [formFieldAccess, setFormFieldAccess] = useState(defaultPermissionsForFields);


    const customDateFormat = "MM/DD/YYYY hh:mm A";

    // Grid Columns: Test Data Documents for a Case Number
    const LegalDetailGridColumns = [
        { field: 'date', headerName: 'Date', minWidth: 100 },
        { field: 'contactID', headerName: 'Contact ID', valueFormatter: (value) => value === 0 ? '' : value, minWidth: 100 },
        { field: 'interactionID', headerName: 'Interaction ID', valueFormatter: (value) => value === 0 ? '' : value, minWidth: 120 },
        { field: 'channel', headerName: 'Channel', minWidth: 80 },
        { field: 'role', headerName: 'Role', minWidth: 60 },
        { field: 'firstName', headerName: 'First Name', minWidth: 100 },
        { field: 'lastName', headerName: 'Last Name', minWidth: 100 },
        { field: 'category', headerName: 'Category', minWidth: 120 },
        { field: 'subCategory', headerName: 'Sub-Category', minWidth: 130 },
        { field: 'action', headerName: 'Action', minWidth: 200 },
        { field: 'actionBy', headerName: 'Action By', minWidth: 120 },
        { field: 'yTracNote', headerName: 'Y-Trac Note', minWidth: 110 },
        { field: 'narrative', headerName: 'Narrative', minWidth: 90 },
    ];

    const LegalDetailGridRows = [
        { id: 1, date: '8/16/2024', contactID: '3952', interactionID: '', channel: 'Walk In',  role: 'CP', firstName: 'Kenisha', lastName: 'Green', category: 'General', subCategory: 'Questions about service', action: 'Referred-Interview Level 1', actionBy: 'Benjamin Winters', yTracNote: 'Question', narrative: 'Walk-In visitor received', },
        { id: 2, date: '7/28/2024', contactID: '3949', interactionID: '', channel: 'Walk In',  role: 'CP', firstName: 'Kenisha', lastName: 'Green', category: 'General', subCategory: 'Application for service', action: 'Referred-Interview Level 1', actionBy: 'Benjamin Winters', yTracNote: 'Application', narrative: 'Walk-In visitor received', },
        { id: 3, date: '4/08/2024', contactID: '3895', interactionID: '', channel: 'Call',  role: 'NCP', firstName: 'Craig', lastName: 'Washington', category: 'Employer', subCategory: 'General Information', action: 'Referred for Follow-Ups Case', actionBy: 'Lauren Peterman', yTracNote: 'General', narrative: 'NCP call regarding', },
        { id: 4, date: '7/12/2024', contactID: '3595', interactionID: '', channel: 'Walk In',  role: 'State', firstName: 'John', lastName: 'Smith', category: 'Medical Support', subCategory: 'Medical Support/OTE', action: 'Referred-Interview Level 2', actionBy: 'LienVi Lee', yTracNote: 'Medical', narrative: '', },
    ];

    const [dropdownValues, setDropdownValues] = useState({
        workflowNumber: '228944',
        court: 'Johnson County',
        courtCaseNumber: '23JC007345',
        legalActionType: 'Support',
        judge: 'Shelley Jones',  
        opposingAttorney: 'Holly Drummond',
        currentAttorney: 'James Corelle',
        currentLegalSpecialist: 'Michael Crown',
        requester: 'CP',
      });

      const [workflowNumberOptions, setWorkflowNumberOptions] = useState([{workflowNumber: '228944'}]);
      const [courtOptions, setCourtOptions] = useState([{court: 'Johnson County'}]);
      const [courtCaseNumberOptions, setCourtCaseNumberOptions] = useState([{courtCaseNumber: '23JC007345'}]);
      const [legalActionTypeOptions, setLegalActionTypeOptions] = useState([{legalActionType: 'Support'}]);
      const [judgeOptions, setJudgeOptions] = useState([{judge: 'Shelley Jones'}]);
      const [opposingAttorneyOptions, setOpposingAttorneyOptions] = useState([{opposingAttorney:'Holly Drummond'}]);
      const [currentAttorneyOptions, setCurrentAttorneyOptions] = useState([{currentAttorney: 'James Corelle'}]);
      const [currentLegalSpecialistOptions, setCurrentLegalSpecialistOptions] = useState([{currentLegalSpecialist: 'Michael Crown'}]);
      const [requesterOptions, setRequesterOptions] = useState([{requester: 'CP'}]);




    //=======================================================================
    //  - Begin
    //=======================================================================

    const simulateAsyncDelay = async () => {
        await new Promise((resolve) => setTimeout(resolve, 0));
    }

    const onLoadLegalDetailByCaseID = async () => {
        try {
            const caseID = PrimaryID;
            setResultsLegalDetail(LegalDetailGridRows);
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "onLoadLegalDetailByCaseID");
        }
    };

    const handleDropdownChange = (field) => (newValue) => {
        setDropdownValues((prev) => ({
            ...prev,
            [field]: newValue,
        }));
    };


      // Function to handle search
      const handleContactsSearch = async (event) => {
        setIsPageLoading(true);
        try {
          await simulateAsyncDelay();
          
        }
        catch (error) {
          await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleContactsSearch");
        }
        finally { setIsPageLoading(false); }
      }; 

      const handleContactsChange = async (e) => {
          try {
          }
          catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleContactsChange");
          }
        };
    
      // Function to handle clear of contact search value
      const handleSearchClear = async () => {
        setIsPageLoading(true);
        try {
          await simulateAsyncDelay();
          
        }
        catch (error) {
          await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleSearchClear");
        }
        finally { setIsPageLoading(false); }
      };


    const handleGridFilterChange = async (newFilterModel) => {
        try {
            setGridFilterModel(newFilterModel);
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleGridFilterChange");
        }
    };

    const handleGridClearFilters = async () => {
        try {
            setGridFilterModel({ items: [] });
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleGridClearFilters");
        }
    };



    //=======================================================================
    //  - End
    //=======================================================================


    //=======================================================================
    // Tabs Feature - Begin
    //=======================================================================


    //=======================================================================
    // Tabs Feature - End
    //=======================================================================



    const mainLegalContent = (
        <div style={{ paddingTop: '5px', width: '100%' }}>
            <div>{/* Middle Section - Document Grid and Buttons  */}
                <Paper elevation={2} className="document-grid" sx={{ boxShadow: "none" }}>
                    {!(formFieldAccess.LegalDetailDgrd?.hide ?? false) && (
                        <div style={{ display: "flex", flexDirection: "column", marginTop: '4px', height: "100%", width: "100%", overflowX: "auto" }}>
                            <div>
                                <CollapsibleSection titleSection={"Legal Details"}>
                                    <div className="grid-container">
                                        <div className="grid-layout">
                                            <div>
                                                <CustomAutoComplete
                                                    customVariant='blueBorderVariant'
                                                    idForControl='workflowNumberSelect'
                                                    labelForControl='Workflow Number'
                                                    valueForControl={dropdownValues.workflowNumber}
                                                    onChange={handleDropdownChange('workflowNumber')}
                                                    optionsSource={workflowNumberOptions}
                                                    labelKey='workflowNumber'
                                                    valueKey='workflowNumber'
                                                    noOptionsText='Workflow Number Not Found'
                                                />
                                            </div>
                                            <div>
                                                <CustomAutoComplete
                                                    customVariant='blueBorderVariant'
                                                    idForControl='courtSelect'
                                                    labelForControl='Court'
                                                    valueForControl={dropdownValues.court}
                                                    onChange={handleDropdownChange('court')}
                                                    optionsSource={courtOptions}
                                                    labelKey='court'
                                                    valueKey='court'
                                                    noOptionsText='Court Not Found'
                                                />
                                            </div>
                                            <div>
                                                <CustomAutoComplete
                                                    customVariant='blueBorderVariant'
                                                    idForControl='courtCaseNumberSelect'
                                                    labelForControl='Court Case Number'
                                                    valueForControl={dropdownValues.courtCaseNumber}
                                                    onChange={handleDropdownChange('courtCaseNumber')}
                                                    optionsSource={courtCaseNumberOptions}
                                                    labelKey='courtCaseNumber'
                                                    valueKey='courtCaseNumber'
                                                    noOptionsText='Court Case Number Not Found'
                                                />
                                            </div>
                                            <div>
                                                <CustomAutoComplete
                                                    customVariant='blueBorderVariant'
                                                    idForControl='legalActionTypeSelect'
                                                    labelForControl='Legal Action Type'
                                                    valueForControl={dropdownValues.legalActionType}
                                                    onChange={handleDropdownChange('legalActionType')}
                                                    optionsSource={legalActionTypeOptions}
                                                    labelKey='legalActionType'
                                                    valueKey='legalActionType'
                                                    noOptionsText='Legal Action Type Not Found'
                                                />
                                            </div>
                                            <div>
                                                <CustomAutoComplete
                                                    customVariant='blueBorderVariant'
                                                    idForControl='judgeSelect'
                                                    labelForControl='Judge'
                                                    valueForControl={dropdownValues.judge}
                                                    onChange={handleDropdownChange('judge')}
                                                    optionsSource={judgeOptions}
                                                    labelKey='judge'
                                                    valueKey='judge'
                                                    noOptionsText='Judge Not Found'
                                                />
                                            </div>
                                            <div>
                                                <CustomAutoComplete
                                                    customVariant='blueBorderVariant'
                                                    idForControl='opposingAttorneySelect'
                                                    labelForControl='Opposing Attorney'
                                                    valueForControl={dropdownValues.opposingAttorney}
                                                    onChange={handleDropdownChange('opposingAttorney')}
                                                    optionsSource={opposingAttorneyOptions}
                                                    labelKey='opposingAttorney'
                                                    valueKey='opposingAttorney'
                                                    noOptionsText='Opposing Attorney Not Found'
                                                />
                                            </div>
                                            <div>
                                                <CustomAutoComplete
                                                    customVariant='blueBorderVariant'
                                                    idForControl='currentAttorneySelect'
                                                    labelForControl='Current Attorney'
                                                    valueForControl={dropdownValues.currentAttorney}
                                                    onChange={handleDropdownChange('currentAttorney')}
                                                    optionsSource={currentAttorneyOptions}
                                                    labelKey='currentAttorney'
                                                    valueKey='currentAttorney'
                                                    noOptionsText='Current Attorney Not Found'
                                                />
                                            </div>
                                            <div>
                                                <CustomAutoComplete
                                                    customVariant='blueBorderVariant'
                                                    idForControl='currentLegalSpecialistSelect'
                                                    labelForControl='Current Legal Specialist'
                                                    valueForControl={dropdownValues.currentLegalSpecialist}
                                                    onChange={handleDropdownChange('currentLegalSpecialist')}
                                                    optionsSource={currentLegalSpecialistOptions}
                                                    labelKey='currentLegalSpecialist'
                                                    valueKey='currentLegalSpecialist'
                                                    noOptionsText='Current Legal Specialist Not Found'
                                                />
                                            </div>
                                            <div>
                                                <CustomAutoComplete
                                                    customVariant='blueBorderVariant'
                                                    idForControl='requesterSelect'
                                                    labelForControl='Requester'
                                                    valueForControl={dropdownValues.requester}
                                                    onChange={handleDropdownChange('requester')}
                                                    optionsSource={requesterOptions}
                                                    labelKey='requester'
                                                    valueKey='requester'
                                                    noOptionsText='Requester Not Found'
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </CollapsibleSection>
                            </div>
                            <div>

                            </div>

                        </div>
                    )}
                </Paper>
            </div>
        </div>
    );



    return (
        <div style={{ height: '100%' }}>
            {mainLegalContent}
        </div>
    );
});

export default LegalCaseDetail;


